import { useState, useEffect, useRef } from 'react';
import Quagga from 'quagga';
import './scanner.css'

function BarcodeScanner() {
  const [barcode, setBarcode] = useState('');
  const scannerContainer = useRef(null);

  useEffect(() => {
    startScanner();
    return () => {
      stopScanner();
    };
  }, []);

  const _onDetected = (result) => {
    setBarcode(result.codeResult.code);
  };

  const startScanner = () => {
    Quagga.init(
      {
        inputStream: {
          type: 'LiveStream',
          target: scannerContainer.current,
          constraints: {
            facingMode: 'environment',
            width: 640,
            height: 480,
          },
        },
        locator: {
          patchSize: 'medium',
          halfSample: true,
        },
        numOfWorkers: navigator.hardwareConcurrency || 4,
        decoder: {
          readers: [
            'code_128_reader',
            'ean_reader',
            'ean_8_reader',
            'code_39_reader',
            'code_39_vin_reader',
            'codabar_reader',
            'upc_reader',
            'upc_e_reader',
            'i2of5_reader',
            '2of5_reader',
            'code_93_reader',
          ],
        },
        locate: true,
      },
      (err) => {
        if (err) {
          console.error('Quagga 初始化失败:', err);
          return;
        }
        Quagga.start();
      }
    );

    Quagga.onDetected(_onDetected);
    Quagga.onProcessed((result) => {
      const drawingCtx = Quagga.canvas.ctx.overlay;
      const drawingCanvas = Quagga.canvas.dom.overlay;

      if (result) {
        if (result.boxes) {
          drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute('width')), parseInt(drawingCanvas.getAttribute('height')));
          result.boxes.filter((box) => box !== result.box).forEach((box) => {
            Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, { color: 'green', lineWidth: 2 });
          });
        }
        if (result.box) {
          Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, { color: '#00F', lineWidth: 2 });
        }
        if (result.codeResult && result.codeResult.code) {
          Quagga.ImageDebug.drawPath(result.line, { x: 'x', y: 'y' }, drawingCtx, { color: 'red', lineWidth: 3 });
        }
      }
    });
  };

  const stopScanner = () => {
    Quagga.offProcessed();
    Quagga.offDetected();
    Quagga.stop();
  };

  return (
    <div className="container">
      <h1 className="title">条形码扫描</h1>
       <div className="controls">
        <button
          onClick={startScanner}
          className="button start"
        >
          开始扫描
        </button>
        <button
          onClick={stopScanner}
          className="button stop"
        >
          停止扫描
        </button>
      </div>
      <div className="result">
        <strong>扫描结果:</strong> {barcode || '未扫描到条形码'}
      </div>
      <div id="scanner-container" ref={scannerContainer} className="scanner"></div>
     
    </div>
  );
}

export default BarcodeScanner;
